// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__g96fB","subheader":"ReorderModal_subheader__299Df","listWrap":"ReorderModal_listWrap__1iooZ"};